import React, { useEffect, useState } from "react";
import { Button } from "../ui/Button";

const EditTicketModal = ({ isOpen, onClose, ticket, onSubmit, analysts, categories = [] }) => {
  const [form, setForm] = useState({
    status: "Aberto",
    priority: "Media",
    category: "",
    assigned_to: "",
    comment: "", // novo comentário
  });

  useEffect(() => {
    if (ticket) {
      setForm({
        status: ticket.status || "Aberto",
        priority: ticket.priority || "Media",
        category: ticket.category || "",
        assigned_to: ticket.assigned_to || "",
        comment: "",
      });
    }
  }, [ticket]);

  if (!isOpen || !ticket) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Enviamos tudo para o pai (Tickets.js):
    // status, priority, category, assigned_to, comment
    await onSubmit(form);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-3xl max-h-[92vh] overflow-y-auto rounded-xl bg-white p-6 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Editar Chamado</h2>
          <Button variant="ghost" size="icon" onClick={onClose} aria-label="Fechar">
            ✕
          </Button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Título apenas para visualização */}
          <div>
            <label className="text-xs font-medium text-gray-600">
              Título do Chamado
            </label>
            <input
              value={ticket.title || ""}
              disabled
              className="w-full border rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-700 cursor-not-allowed"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Status */}
            <div>
              <label className="text-xs font-medium text-gray-600">
                Status
              </label>
              <select
                name="status"
                value={form.status}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 text-sm"
              >
                <option value="Aberto">Aberto</option>
                <option value="Em Andamento">Em Andamento</option>
                <option value="Encerrado">Encerrado</option>
                <option value="Cancelado">Cancelado</option>
              </select>
            </div>

            {/* Prioridade */}
            <div>
              <label className="text-xs font-medium text-gray-600">
                Prioridade
              </label>
              <select
                name="priority"
                value={form.priority}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 text-sm"
              >
                <option value="Baixa">Baixa</option>
                <option value="Media">Média</option>
                <option value="Alta">Alta</option>
                <option value="Urgente">Urgente</option>
              </select>
            </div>

            {/* Categoria (listbox alimentado pelo cadastro de categorias) */}
            <div>
              <label className="text-xs font-medium text-gray-600">
                Categoria
              </label>
              <select
                name="category"
                value={form.category}
                onChange={handleChange}
                className="w-full border rounded-lg px-3 py-2 text-sm"
              >
                <option value="">— Sem categoria —</option>
                {/* mantém o valor atual mesmo que não esteja mais na lista (legado) */}
                {form.category &&
                  !categories.some((c) => c.name === form.category) && (
                    <option value={form.category}>{form.category}</option>
                  )}
                {categories.map((c) => (
                  <option key={c.id} value={c.name}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Responsável / Fila */}
          <div>
            <label className="text-xs font-medium text-gray-600">
              Responsável / Fila
            </label>
            <select
              name="assigned_to"
              value={form.assigned_to}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 text-sm"
            >
              <option value="">— Não atribuído —</option>
              {analysts.map((analyst) => {
                const fullName = `${analyst.first_name || ""} ${
                  analyst.last_name || ""
                }`.trim();
                return (
                  <option key={analyst.id} value={fullName}>
                    {fullName}
                  </option>
                );
              })}
            </select>
            <p className="mt-1 text-xs text-gray-400">
              Use esta lista para transferir o chamado para outro analista ou
              trazer para a sua própria fila.
            </p>
          </div>

          {/* Novo Comentário */}
          <div>
            <label className="text-xs font-medium text-gray-600">
              Novo comentário (opcional)
            </label>
            <textarea
              name="comment"
              value={form.comment}
              onChange={handleChange}
              rows={3}
              placeholder="Detalhe o que foi feito, próximo passo, contato com usuário, etc."
              className="w-full border rounded-lg px-3 py-2 text-sm"
            />
            <p className="mt-1 text-xs text-gray-400">
              Este comentário será registrado no histórico do chamado.
            </p>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit">
              Salvar alterações
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTicketModal;
